import { useSearchParams } from 'react-router-dom';

import { HomePageV1 } from './HomePage';

/**
 * Home UI rollout is fully disabled — every user sees the legacy v1
 * Auto/Manual flow regardless of `abGroup`. The v2 plan-modal UI is kept
 * in the codebase (and still reachable via `?plan=<orderId>` so any
 * in-flight plan links keep working) but is no longer rolled out to anyone.
 */
export function HomePageRoot() {
  const [searchParams, setSearchParams] = useSearchParams();

  const resumePlanOrderId = searchParams.get('plan') || undefined;
  const uiVersion = resumePlanOrderId ? 'v2' : 'v1';

  const clearResumeParam = () => {
    if (!searchParams.has('plan')) return;
    const next = new URLSearchParams(searchParams);
    next.delete('plan');
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="w-full">
      <HomePageV1
        uiVersion={uiVersion}
        resumePlanOrderId={resumePlanOrderId}
        onResumeConsumed={clearResumeParam}
      />
    </div>
  );
}
